import { toast } from "react-toastify"
import React, { useEffect, useState } from "react"
import { ListboxButton, ListboxOption } from "@headlessui/react"

import { RouteHydration } from "../../utils/Helpers"
import { ListBox } from "../../lib/fragments/ListBox"
import { InputRegistry } from "../../utils/Interfaces"
import HttpServices from "../../services/HttpServices"
import { PEOPLE_PROFILE } from "../../api/Registry"
import { Checkbox } from "../../components/utils/Checkbox"
import { DynamicModal } from "../../lib/fragments/DynamicModal"
import { FloatingInput } from "../../components/utils/FloatingInput"
import { APPLICATION, TARGETED_AUDIENCE } from "../../utils/Constants"
import { FloatingTextArea } from "../../components/utils/FloatingTextArea"
import { G_onInputChangeHandler, G_ValidationLogic } from "../../components/utils/InputHandlers"

export const CreateOrEditProfileGroup = ({ show, showOrHide, onComplete, cargo }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'pending',
        data: {
            group: null,
        }, input: {
            title: '',
            hint: '',
            audience: null,
            add_another: '',
        }, errors: {
            title: '',
            hint: '',
            audience: '',
        }, httpError: {
            title: null,
            message: null
        }
    })

    const isCreate = cargo.action === 'create';
    const modalTitle = `${isCreate ? 'Create' : 'Edit'} Profile Group`;
    const actionLabel = isCreate ? 'Create' : 'Update';

    const inputRegistry: InputRegistry[] = [
        {
            display_type: 'input',
            name: 'title',
            title: 'Group Label',
            validation: 'alphanumeric',
        },
        {
            display_type: 'textarea',
            name: 'hint',
            title: 'Hint',
            validation: 'comments_descriptions',
        },
    ]

    const getProfileGroupDetails = async () => {
        let { data, input, httpStatus, status, httpError } = state

        try {
            const profileGroupRoute = [":group"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [cargo.uuid][index]),
                    PEOPLE_PROFILE.GROUP_RESOURCE
                );

            const response: any = await HttpServices.httpGet(profileGroupRoute)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload
                data.group = payload.group

                const targetedAudience = TARGETED_AUDIENCE.find(
                    (audience: any) => audience.key === data.group.a
                )

                input.title = data.group.e
                input.hint = data.group.t
                input.audience = targetedAudience

                status = 'fulfilled'
            } else {
                status = 'rejected'

                if (response.data.message) {
                    httpError.message = response.data.message
                    httpError.title = response.status === 403
                        ? "Action Denied"
                        : "Request Failed"
                }
            }
        } catch (error) {
            httpStatus = 500
            status = 'rejected'
        }

        setstate((prev: any) => ({
            ...prev,
            data,
            input,
            status,
            httpError,
            httpStatus,
        }))
    }

    const fulfillStatusForCreateAction = () => {
        setTimeout(() => {
            const targetedAudience = TARGETED_AUDIENCE.find(
                (audience: any) => audience.key === 'global'
            )

            setstate((prev: any) => ({
                ...prev,
                input: {
                    ...prev.input,
                    audience: targetedAudience
                },
                status: 'fulfilled'
            }))
        }, 500);
    }

    useEffect(() => {
        if (show) {
            cargo.action === 'edit'
                ? getProfileGroupDetails()
                : fulfillStatusForCreateAction()
        }
    }, [show, cargo])

    const onCloseModal = async () => {
        showOrHide()

        // Reset the state on close
        setTimeout(() => {
            setstate((prev: any) => ({
                ...prev,
                posting: false,
                httpStatus: 200,
                status: 'pending',
                data: {
                    group: null
                },
                input: {
                    ...prev.input,
                    title: '',
                    add_another: '',
                    hint: '',
                },
                errors: {
                    ...prev.errors,
                    title: '',
                    hint: '',
                }
            }))
        }, 300)
    }

    const onChangeHandler = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        let output: any = G_onInputChangeHandler(e)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onInputBlur = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        const whichInput = inputRegistry.find(
            (registry: any) => registry.name === e.target.name
        )

        if (!whichInput) {
            console.log(`Object Not Found: ${e.target.name}`) // Object Not Found: 
            return
        }

        let output: any = G_ValidationLogic(e, whichInput.validation, whichInput.title)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onListBoxHandler = (e: any) => {
        let { posting, errors } = state
        let errorMsg = ''

        if (posting) return

        let updatedErrors = {
            ...errors
        }

        const targetedAudience = TARGETED_AUDIENCE.find(
            (audience: any) => audience.key === e.key
        )

        if (!e || !targetedAudience) {
            errorMsg = 'Kindly select the target audience'
        }

        updatedErrors = {
            ...updatedErrors,
            audience: errorMsg,
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                audience: e,
            },
            errors: updatedErrors
        }));
    }

    const profileGroupFormHandler = (e: any) => {
        e.preventDefault()

        let valid = true
        let { posting, input } = state

        if (posting) return

        const fieldsToValidate = [
            'title',
            'hint',
        ]

        fieldsToValidate.forEach((inputKey: any) => {
            try {
                let oTarget = e.target[inputKey]

                let syntheticEvent: any = {
                    target: {
                        name: oTarget.name,
                        required: oTarget.required,
                        value: oTarget.value.trim(),
                    }
                }

                onInputBlur(syntheticEvent)
            } catch (error) {
                // Override error
            }
        })

        let { errors } = state
        const errorArray = Object.keys(errors)

        errorArray.forEach((errorObject: any) => {
            if (errors[errorObject].length > 0) {
                valid = false
            }
        })

        if (valid) {
            setstate((prev: any) => ({
                ...prev,
                posting: true,
            }))

            profileGroupDataHandler()
        }
    }

    const profileGroupDataHandler = async () => {
        let { input, errors, httpStatus } = state

        try {
            let formData = new FormData()
            formData.append('title', input.title)
            formData.append('hint', input.hint)
            formData.append('audience', input.audience.key)

            const profileGroupRoute = cargo.action === 'create'
                ? PEOPLE_PROFILE.GROUP_COLLECTION
                : [":group"]
                    .reduce((route, param, index) =>
                        RouteHydration(route, param, [cargo.uuid][index]),
                        PEOPLE_PROFILE.GROUP_RESOURCE
                    )

            const response: any = cargo.action === 'create'
                ? await HttpServices.httpPost(profileGroupRoute, formData)
                : await HttpServices.httpPut(profileGroupRoute, formData);

            httpStatus = response.status

            if (httpStatus === 200) {
                if (input.add_another === 'Y') {
                    const targetedAudience = TARGETED_AUDIENCE.find(
                        (audience: any) => audience.key === 'global'
                    )

                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            title: '',
                            hint: '',
                            audience: targetedAudience
                        }
                    }));
                } else {
                    onCloseModal()
                }

                onComplete()
            } else {
                if (httpStatus === 422) {
                    Object.entries(response.data).forEach(([field, errorMessages]) => {
                        const submissionErrors = {
                            ...errors,
                            [field]: errorMessages
                        };

                        setstate((prev: any) => ({
                            ...prev,
                            errors: submissionErrors,
                        }));
                    });
                } else {
                    toast.error(APPLICATION.ERR_MSG);
                }
            }
        } catch (error) {
            toast.error(APPLICATION.ERR_MSG);
        }

        setstate((prev: any) => ({
            ...prev,
            posting: false,
            httpStatus
        }));
    }

    return (
        <React.Fragment>
            <DynamicModal
                size={'md'}
                show={show}
                title={modalTitle}
                status={state.status}
                posting={state.posting}
                error={state.httpError}
                actionName={actionLabel}
                showOrHide={onCloseModal}
                onSubmit={profileGroupFormHandler}
                content={
                    <>
                        <header className="w-full mb-2 header-title flex flex-col md:gap-y-1 gap-y-1">
                            <p className="text-sm pb-2 text-slate-500 dark:text-slate-400">
                                Grouping helps structure profiles and improve clarity across user configurations.
                            </p>
                        </header>


                        <div className="w-full pb-6 md:max-w-md">
                            <ListBox
                                value={state.input.audience}
                                eventHandler={(e: any) => onListBoxHandler(e)}
                                label={
                                    <>
                                        <p className="text-sm font- text-slate-600 dark:text-slate-300 tracking-wide">
                                            Targeted Audience
                                        </p>

                                        <p className="w-full text-slate-500 dark:text-slate-400 pb-1 text-xs">
                                            Visibility and access scope for this group
                                        </p>
                                    </>
                                }
                                button={
                                    <ListboxButton className="relative w-full bg-white border border-slate-200 rounded-md py-2.5 pl-1 pr-3 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 sm:text-sm">
                                        <span className="flex w-full items-center align-middle">
                                            <div className="flex-grow flex items-center">
                                                <span className="ml-3 block truncate">
                                                    {state.input.audience?.label}
                                                </span>
                                            </div>

                                            <span className="fa-light fa-chevron-down float-end"></span>
                                        </span>

                                    </ListboxButton>
                                }
                                options={
                                    TARGETED_AUDIENCE.map((audience: any) => (
                                        <ListboxOption key={`t$-aud-${audience.key}`} value={audience} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                            <div className="flex items-center gap-x-4">
                                                <span className="truncate group-data-[selected]:font-medium">
                                                    {audience.label}
                                                </span>
                                            </div>

                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                <span className="fa-light fa-check"></span>
                                            </span>
                                        </ListboxOption>
                                    ))
                                }
                            />
                        </div>

                        <div className="w-full pb-6">
                            <FloatingInput
                                required={true}
                                name={"title"}
                                posting={state.posting}
                                label={"Group Label *"}
                                blurHandler={onInputBlur}
                                changeHandler={onChangeHandler}
                                value={state.input.title}
                                error={state.errors.title}
                            />
                        </div>

                        <div className="w-full pb-3">
                            <FloatingTextArea
                                required={false}
                                name={"hint"}
                                posting={state.posting}
                                label={
                                    <span className="flex items-center gap-1">
                                        Hint <span className="text-xs text-slate-500 dark:text-slate-400">(Optional)</span>
                                    </span>
                                }
                                blurHandler={onInputBlur}
                                changeHandler={onChangeHandler}
                                value={state.input.hint}
                                error={state.errors.hint}
                            />

                            <p className="text-xs pb-4 pt-1 text-slate-500 dark:text-slate-400">
                                A brief description for others to understand the purpose of this group
                            </p>
                        </div>

                        {
                            cargo.action === 'create' && (
                                <Checkbox
                                    value={state.input.add_another}
                                    name={'add_another'}
                                    disabled={false}
                                    posting={state.posting}
                                    checked={state.input.add_another === 'Y'}
                                    required={false}
                                    changeHandler={onChangeHandler}
                                    label={
                                        <>
                                            <div className="text-slate-600 dark:text-slate-500">
                                                <span className="block">Create another</span>
                                            </div>
                                        </>
                                    }
                                />
                            )
                        }

                    </>
                }
            />
        </React.Fragment>
    )
}